/* =========================================================================
   Schedule day-tabs. Tabs and day panels are server-rendered by the section;
   this only wires the click-to-switch behaviour. Scoped per section.
   ========================================================================= */
(function () {
  document.querySelectorAll("[data-schedule]").forEach(function (root) {
    var tabs = root.querySelector(".day-tabs");
    var daysWrap = root.querySelector("[data-schedule-days]");
    if (!tabs || !daysWrap) return;

    tabs.addEventListener("click", function (e) {
      var btn = e.target.closest(".day-tab");
      if (!btn) return;
      var id = btn.getAttribute("data-day");
      tabs.querySelectorAll(".day-tab").forEach(function (b) {
        b.classList.toggle("is-active", b === btn);
      });
      daysWrap.querySelectorAll(".schedule-day").forEach(function (d) {
        d.classList.toggle("is-active", d.getAttribute("data-day") === id);
      });
    });
  });
})();
